mutation DeleteEventChatOverlay($eventId: ID!, $chatId: ID!) {
  result: StreamToolsDeleteEventChatOverlay(eventId: $eventId, chatId: $chatId) {
    id
    deleted
  }
}
